<template>
  <div class="page-wrapper">
    <div class="page-header">
      <WidgetToolbar
        :back="true"
        title="Accounts"
        :icon="require('@/assets/icon/accounts-active.svg')"
        @onBack="$navigationGoBack('/accounts')"
      >
        <div class="options">
          <widgetSearch
            class="search-account"
            placeholder="Type in to Search..."
            icon="right"
            v-model="search_input"
          ></widgetSearch>

          <div class="h-spacer"></div>

          <widgetDropdown
            v-model="sort_input_filter"
            :right="true"
            :hover="false"
            :interactive="true"
          >
            <button class="btn-dropdown">
              <span style="width: 80px" v-if="selected_filter == 'all'"
                >All Activities</span
              >
              <span v-if="selected_filter == 'today'">Today</span>
              <span v-if="selected_filter == 'last_week'">Last week</span>
              <span v-if="selected_filter == 'last_month'">Last month</span>
              <span v-if="selected_filter == 'last_year'">Last year</span>
              <img class="icon" src="@/assets/icon/carret-bottom-gray.svg" />
            </button>
            <div slot="dropdown" class="dropdown-widget right">
              <a
                class="dropdown-item"
                href="#"
                v-for="(item, index) in view_filter"
                :key="index"
                @click="filterActivities(item.value)"
              >
                {{ item.name }}</a
              >
            </div>
          </widgetDropdown>
        </div>
      </WidgetToolbar>
    </div>
    <div class="page-tab">
      <div class="page-path-widget">
        <img
          @click="$router.push({ path: '/accounts' })"
          src="@/assets/icon/accounts-active.svg"
          class="icon"
        />
        <label
          @click="$router.push({ path: '/accounts' })"
          class="path-name link"
          >Accounts</label
        >
        <img src="@/assets/icon/outline-carret-green.svg" class="allow" />
        <label class="path-name"> {{ account.name }} </label>
      </div>

      <div class="page-tab-options row">
        <widgetButton
          :loading="false"
          @click="getAllNotes()"
          class="btn-transparent fit-content"
        >
          <img src="@/assets/icon/reflesh-gray.svg" />
        </widgetButton>
      </div>
    </div>
    <div class="page-body">
      <accountSidebar
        switch_tab="activities"
        :account="account"
      ></accountSidebar>
      <div
        class="instruct-wrapper"
        v-if="activities_data.length > 0 || isLoading"
      >
        <div class="tab-options"></div>
        <div class="instruct-widget">
          <multipane class="custom-resizer" layout="vertical">
            <div class="instruct-list">
              <div class="instruct-body">
                <table class="table-data">
                  <thead class="table-header">
                    <tr>
                      <th class="stick-title" width="200">Created Date</th>

                      <th class="stick-title" width="250">
                        <div class="force-start">Activity</div>
                      </th>
                      <th class="stick-title" width="150">Created by</th>
                    </tr>
                  </thead>
                  <tbody class="table-body">
                    <template>
                      <tr
                        class="row-data"
                        v-for="(item, index) in activities_data"
                        :key="index"
                        @click="selectActivity(item)"
                      >
                        <td>
                          <div class="date-widget">
                            <img src="@/assets/admin-icon/activity.svg" />
                            <span> {{ item.created_at | formatDateTime }}</span>
                          </div>
                        </td>

                        <td>
                          <div class="activity-content">
                            <div class="activity-label">{{ item.action }}</div>
                          </div>
                        </td>
                        <td class="email">{{ item.created_by }}</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
                <!-- Loading preview -->
                <div class="loading-widget" v-if="isLoading">
                  <loading
                    :height="40"
                    :width="40"
                    :active="true"
                    color="#000"
                    :is-full-page="false"
                  />
                </div>
              </div>
            </div>
            <multipane-resizer v-if="selected_activity"></multipane-resizer>
            <div
              class="instruct-details"
              v-if="selected_activity"
              :style="{ flexGrow: 1 }"
            >
              <div class="activity-preview">
                <div class="activity-preview-header">
                  <img src="@/assets/admin-icon/activity-icon.svg" />
                </div>
                <div class="activity-preview-body">
                  <div class="activity-info-widget">
                    <label>Action</label>
                    <p>
                      {{ selected_activity.action }}
                    </p>
                  </div>
                  <div class="activity-info-widget">
                    <label>Created date</label>
                    <p>{{ selected_activity.created_at | formatDateTime }}</p>
                  </div>
                  <div class="activity-info-widget">
                    <label>Created by</label>
                    <p>{{ selected_activity.created_by }}</p>
                  </div>
                  <div class="activity-info-widget">
                    <p>
                      <a
                        v-if="selected_activity.type == 'tasks'"
                        @click.prevent="viewItem(selected_activity)"
                        class="link"
                        >View Task</a
                      >
                      <a
                        v-if="selected_activity.type == 'leads'"
                        @click.prevent="viewItem(selected_activity)"
                        class="link"
                        >View Lead</a
                      >
                      <a
                        v-if="selected_activity.type == 'notes'"
                        @click.prevent="viewItem(selected_activity)"
                        class="link"
                        >View Note</a
                      >
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </multipane>
        </div>
      </div>
      <div class="instruct-wrapper" v-else>
        <div class="student-not-found-widget">
          <widgetNotFoundWidget
            title="No Activities Found"
            content="Nothing happened in this account"
            @click="() => {}"
          >
            <img
              class="widget-img"
              src="@/assets/admin-icon/student-search-icon.svg"
            />
          </widgetNotFoundWidget>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { eventBus } from "@/main";
import accountSidebar from "@/views/Accounts/components/account_sidebar.vue";

export default {
  name: "",
  components: {
    accountSidebar,
  },
  data: () => {
    return {
      sort_input_filter: false,
      account: {},
      search_input: "",
      selected_filter: "all",
      view_filter: [
        {
          value: "all",
          name: "All Activities",
        },
        {
          value: "today",
          name: "Today",
        },
        {
          value: "last_week",
          name: "Last week",
        },
        {
          value: "last_month",
          name: "Last month",
        },
        {
          value: "last_year",
          name: "Last year",
        },
      ],
      activities_data: [],
      selected_activity: null,
      isLoading: false,
      show_selected_activities_options: false,
      form_filter: {
        account_id: null,
        filter_by: "all",
        query: "",
      },
    };
  },
  mounted() {
    let vm = this;
    vm.getAllActivities();
    vm.getStartData();
  },
  computed: {},
  watch: {
    search_input(query) {
      let vm = this;
      vm.searchActivity(query);
    },
    selected_filter(type) {
      let vm = this;
      if (type == "all") {
        vm.getAllActivities();
      } else {
        vm.filterActivities(type);
      }
    },
  },
  methods: {
    getStartData() {
      let vm = this;
      vm.$store.dispatch("LOADER_START");
      vm.$store
        .dispatch("ACCOUNT_SINGLE_GET_ALL_DATA", {
          account_id: vm.$route.params.id,
        })
        .then((responce) => {
          vm.$store.dispatch("LOADER_CLOSE");
          vm.account = responce.data;
        })
        .catch((error) => {
          vm.$store.dispatch("LOADER_CLOSE");
        });
    },
    deletedSelectedActivity() {
      let vm = this;
      vm.$store
        .dispatch("ACTIVITIES_DELETE_SELECTED", {
          ids: vm.validateCheckedActivities("data"),
        })
        .then((responce) => {
          vm.getAllActivities();
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Selected activity is now deleted",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Something went wrong, try again",
            type: "warn",
            duration: 3000,
          });
        });
    },
    filterActivities(filter) {
      let vm = this;
      vm.sort_input_filter = false;
      vm.selected_filter = filter;
      vm.form_filter.filter_by = filter;
      vm.getAllActivities();
    },
    searchActivity(query) {
      let vm = this;
      vm.form_filter.query = query;
      vm.getAllActivities();
    },
    getAllActivities() {
      let vm = this;
      vm.isLoading = true;
      vm.form_filter.account_id = vm.$route.params.id;
      vm.$store
        .dispatch("ACTIVITIES_GET_ALL", vm.form_filter)
        .then((responce) => {
          vm.isLoading = false;
          vm.activities_data = responce.data.map((item) => {
            eventBus.$set(item, "checked", false);
            return item;
          });
        })
        .catch((error) => {
          vm.isLoading = false;
        });
    },
    selectActivity(item) {
      let vm = this;
      vm.selected_activity = item;
    },
    deleteActivity(item) {
      let vm = this;
      vm.$store
        .dispatch("ACTIVITIES_DELETE", {
          id: item.id,
        })
        .then((responce) => {
          vm.getAllActivities();
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Activity is now deleted",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Something went wrong, try again",
            type: "warn",
            duration: 3000,
          });
        });
    },
    validateCheckedActivities(type = "validate") {
      let vm = this;
      if (type == "validate") {
        vm.show_selected_activities_options =
          vm.activities_data
            .map((item) => item.checked)
            .filter((item) => item == true).length > 0;
        return;
      }
      return vm.activities_data
        .filter((item) => item.checked == true)
        .map((item) => item.id);
    },
    checkAllActivities({ target }) {
      let vm = this;
      if (target.checked) {
        vm.activities_data = vm.activities_data.map((item) => {
          eventBus.$set(item, "checked", true);
          return item;
        });
      } else {
        vm.activities_data = vm.activities_data.map((item) => {
          eventBus.$set(item, "checked", false);
          return item;
        });
      }
      vm.validateCheckedActivities();
    },
    checkActivity(item) {
      let vm = this;
      item.checked = !item.checked;
      vm.validateCheckedActivities("validate");
    },
    viewItem(data) {
      let vm = this;
      if (data.type == "tasks") {
        vm.$router.push({
          name: "task",
          params: { id: data.reference_id },
        });
      } else if (data.type == "leads") {
        vm.$router.push({
          name: "leads",
          params: { id: data.reference_id },
        });
      } else if (data.type == "notes") {
        vm.$router.push({
          name: "account-note-view",
          params: {
            type: "notes",
            id: vm.$route.params.id,
            note_id: data.reference_id,
          },
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
$assets: "~@/assets";
.page-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #ebebeb;
  padding: 10px;
  .page-header {
    height: 50px;
    width: 100%;
    display: flex;
    align-items: center;
    .options {
      display: flex;
      align-items: center;
      .search-account {
        width: 250px;
      }
      .btn-add {
        margin-left: 20px;
        width: 130px;
      }
    }
  }
  .page-tab {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 50px;
    .page-path-widget {
      display: flex;
      align-items: center;
      .icon {
        width: 20px;
        margin-top: -10px;
        margin-right: 10px;
        cursor: pointer;
      }
      .allow {
        margin: 0px 10px;
      }
      .path-name {
        color: #1ba5a4;
        font-size: 15px;
        &.link {
          cursor: pointer;
        }
      }
    }
  }
  .page-body {
    height: calc(100% - 100px);
    display: flex;
    width: 100%;
    .instruct-wrapper {
      width: calc(100% - 240px);
      height: 100%;
      display: flex;
      flex-direction: column;
      .instruct-widget {
        height: 100%;
        position: relative;
        .custom-resizer {
          height: 100%;
        }
        .instruct-list {
          display: flex;
          flex-direction: column;
          height: 100%;
          min-width: calc(100% - 450px);
          width: 100%;
          border-radius: 5px;
          padding: 5px;
          background: #fff;
          position: relative;
          .instruct-header {
            height: 150px;
            background: #fff;
            .search-add-btn-widget {
              padding: 15px 10px;
              padding-bottom: 0px;
              display: grid;
              grid-column-gap: 20px;
              border-top-right-radius: 5px;
              border-top-left-radius: 5px;
              .search-widget {
                border: 3px solid #ccc;
                height: 45px;
                display: flex;
                align-items: center;
                padding: 0px 10px;
                border-radius: 5px;
                img {
                  width: 25px;
                  height: 25px;
                }
                input {
                  height: 40px;
                  width: 100%;
                  padding-left: 15px;
                  outline: none;
                  border: none;
                }
              }
              .add-btn {
                width: 191px;
                height: 45px;
                background: #1885ad 0% 0% no-repeat padding-box;
                border-radius: 5px;
                opacity: 1;
                color: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
                img {
                  margin-left: 10px;
                }
              }
            }
            .school-widget {
              padding: 0px 10px;
              padding-top: 10px;
              display: flex;
              justify-content: space-between;
              h2 {
                margin: 0px;
                font-size: 18px;
              }
            }
            .filter-widget {
              display: flex;
              padding: 0px 10px;
              justify-content: space-between;
              .filter-title {
                color: rgb(156, 156, 156);
              }
              .filter-select-widget {
                display: flex;
                align-items: center;
                cursor: pointer;
                .filter-selected-label {
                  span {
                    color: #0884af;
                  }
                }
              }
              .table-options {
                display: flex;
                align-items: center;
                .btn-assign {
                  background: #1ba5a4;
                  border-radius: 5px;
                  width: auto;
                  height: 34px;
                  display: block;
                  color: #fff;
                  display: flex;
                  align-items: center;
                  padding: 0px 20px;
                  margin-right: 5px;
                }
                .btn-delete {
                  position: relative;
                  top: 3px;
                }
              }
            }
          }
          .instruct-body {
            height: 100%;
            overflow-y: auto;
            padding-bottom: 60px;
            .table-data {
              border-collapse: collapse;
              border-spacing: 0;
              width: 100%;
              tr {
                &.row-data {
                  background: #fff;
                }
                &:hover {
                  background: rgb(248, 248, 248);
                  cursor: pointer;
                }
                &.hovering {
                  background: #1885ad15;
                }

                th {
                  border-bottom: none;
                  padding: 20px 3px !important;
                  text-align: left;
                  color: #334d6eb0;
                  font-size: 12px;
                  &.stick-title {
                    position: sticky;
                    top: 0px;
                    background: #fff;
                    z-index: 999;
                  }
                  &.center {
                    display: flex;
                    align-content: center;
                    input {
                      position: relative;
                      top: 0px;
                      margin-right: 5px;
                      margin: 0px 20px;
                    }
                  }
                  .force-start {
                    display: flex;
                    align-items: center;
                    input {
                      position: relative;
                      top: -1px;
                      left: -7px;
                      margin-right: 5px;
                    }
                  }
                  &.text-center {
                    text-align: center;
                  }
                }
                td {
                  text-align: left;
                  border-bottom: none;
                  padding: 8px 3px;
                  font-size: 13px;
                  color: rgb(28, 28, 28);
                  border-bottom: 1px solid #ebeff2;

                  .activity-content {
                    display: flex;
                    align-items: center;
                    width: 250px;
                    .checkbox {
                      position: relative;
                      top: -1px;
                      left: -7px;
                      margin-right: 5px;
                    }
                    .activity-label {
                      display: block;
                      overflow: hidden;
                      text-decoration: none;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                    }
                  }
                  .date-widget {
                    display: flex;
                    align-items: center;
                    img {
                      margin-right: 10px;
                    }
                  }
                  .company-widget-list {
                    display: flex;
                    align-items: center;
                    .company-item {
                      display: flex;
                      align-items: center;
                      .intern-image {
                        width: 10px;
                        margin-right: 2px;
                      }
                      .company-widget {
                        display: flex;
                        align-items: center;
                        background: #0884af;
                        padding: 2px;
                        border-radius: 50%;
                        position: relative;
                        width: 37px;
                        height: 37px;
                        transition: 0.6s ease-in-out;
                        &.internal {
                          margin-left: 12px;
                        }
                        &:hover {
                          width: 110px;
                          border-radius: 50px;
                          transition: 0.6s ease-in-out;
                        }
                        img {
                          width: 33px;
                          height: 33px;
                          border-radius: 50%;
                        }
                        span {
                          font-size: 13px;
                          color: #fff;
                          margin-right: 4px;
                          margin-left: 4px;
                          overflow: hidden;
                          text-decoration: none;
                          text-overflow: ellipsis;
                          white-space: nowrap;
                        }
                        .btn-remove {
                          position: absolute;
                          top: -9px;
                          right: -2px;
                          background: #640303;
                          color: #fff;
                          border-radius: 45px;
                          display: none;
                        }
                        &:hover {
                          .btn-remove {
                            display: block;
                          }
                        }
                      }
                    }
                  }
                  .profile-content {
                    display: flex;
                    align-items: center;
                    .student-profile {
                      height: 35px !important;
                      width: 35px !important;
                      background: #1ba5a4;
                      border-radius: 50%;
                      margin-right: 10px;
                    }
                    .profile-alphabet {
                      margin-right: 10px;
                      height: 35px !important;
                      width: 35px !important;
                      background: #1ba5a4;
                      border-radius: 50%;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      span {
                        font-size: 13px;
                        color: #fff;
                      }
                    }
                  }
                  .internship-status {
                    padding: 8px 10px;
                    width: 130px;
                    border-radius: 5px;
                    text-align: center;
                    cursor: auto;
                    &.sent {
                      border: 1px solid #1ba5a4;
                      color: #1ba5a4;
                    }
                    &.waiting {
                      border: 1px solid #0884af;
                      color: #0884af;
                    }
                  }
                  .progress-widget {
                    width: 80px;
                  }
                  .table-menu {
                    position: relative;
                  }
                  .center {
                    display: flex;
                    justify-content: center;
                  }
                  &:first-child {
                    border-top-left-radius: 5px;
                    border-bottom-left-radius: 5px;
                  }
                  &:last-child {
                    border-top-right-radius: 5px;
                    border-bottom-right-radius: 5px;
                  }

                  &.text-center {
                    text-align: center;
                  }
                  &.email {
                    color: #334d6eb0;
                    font-size: 13px;
                  }
                  .btn-invite {
                    width: 85px;
                    height: 33px;
                    background: #0884af;
                    border-radius: 5px;
                    color: #fff;
                  }
                  .btn-approve {
                    width: 92px;
                    height: 33px;
                    background: #1ba5a4;
                    border-radius: 5px;
                    color: #fff;
                  }
                }
              }
            }
          }
        }
        .instruct-details {
          width: 300px;
          min-width: 300px;
          max-width: 400px;
          display: flex;
          flex-direction: column;
          height: 100%;
          background: #fff;
          border-radius: 5px;

          .activity-preview {
            height: 100%;
            min-width: calc(100% - 700px);
            background: #fff;
            width: 100%;
            border-radius: 5px;
            padding: 10px;
            display: flex;
            flex-direction: column;
            @media (min-width: 300px) and (max-width: 630px) {
              display: none;
            }
            .activity-preview-header {
              padding: 10px 10px;
              img {
                width: 40px;
              }
            }
            .activity-preview-body {
              .activity-info-widget {
                margin-bottom: 18px;
                label {
                  font-size: 15px;
                  color: #9f9f9f;
                  margin-top: 4px;
                }
                p {
                  font-size: 20px;
                  color: #000000;
                  margin: 0px;
                }
                .link {
                  color: #0884af;
                  text-decoration: none;
                  display: block;
                  margin-top: 50px;
                  cursor: pointer;
                }
              }
            }
          }
          .empty-widget {
            display: flex;
            align-content: center;
            justify-content: center;
            h1 {
              font-size: 20px;
              color: #ddd;
              margin-top: 200px;
            }
          }
        }
      }

      .student-not-found-widget {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        background: #fff;
        border-radius: 5px;
      }
      .form-widget-modal {
        width: 500px;
        min-height: 200px;
        padding: 20px;
        .moder-header {
        }
        .modal-body {
          .input-group {
            position: relative;
            .exist-company {
              width: 100%;
              .input-form {
                width: 100%;
              }
              .selected-company {
                border: 1px solid #ddd;
                background: #fff;
                height: 50px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0px 10px;
                .content {
                  display: flex;
                  align-items: center;
                  img {
                    width: 30px;
                    height: 30px;
                    margin-right: 10px;
                  }
                }
                .option {
                  .btn-close {
                    font-size: 20px;
                    background: #7f0404;
                    color: #fff;
                    border-radius: 5px;
                  }
                }
              }
              .search-result-widget {
                position: absolute;
                top: 75px;
                height: 200px;
                width: 100%;
                background: #fff;
                z-index: 999;
                box-shadow: 0px 0px 3px #ccc;
                border-radius: 5px;
                overflow-y: auto;
                .search-item {
                  display: flex;
                  align-items: center;
                  padding: 4px 10px;
                  border-bottom: 1px solid #ddd;
                  cursor: pointer;
                  &:hover {
                    background: rgb(240, 240, 240);
                  }
                  img {
                    width: 40px;
                    height: 40px;
                    object-fit: cover;
                    border-radius: 50%;
                    margin-right: 15px;
                  }
                }
              }
            }
            .new-company-field {
              width: 100%;
              .input-form {
                width: 100%;
              }
            }
          }
        }
      }
    }
  }
}
.search-contact-item {
  padding: 10px 15px;
  display: flex;
  cursor: pointer;
  align-items: center;
  img {
    border-radius: 50%;
    margin-right: 8px;
  }
  &:hover {
    background: rgb(250, 250, 250);
  }
}
.selected-search-contact-item {
  padding: 5px 12px;
  display: flex;
  align-items: center;
  cursor: pointer;
  border: 1px solid #ddd;
  margin-top: 10px;
  border-radius: 15px;
  font-size: 11px;
  img {
    border-radius: 50%;
    margin-right: 8px;
  }
  &:hover {
    background: rgb(250, 250, 250);
  }
}
</style>
